import React, { useId, useRef } from "react";
import { cn } from "./cn";

export default function Tabs({
  items,
  active,
  onChange,
  className,
  idPrefix,
  ariaLabel = "Tabs",
}) {
  const generatedId = useId();
  const prefix = idPrefix ?? `tabs-${generatedId.replace(/[:]/g, "")}`;
  const tabRefs = useRef([]);

  const focusAndSelect = (index) => {
    const bounded = (index + items.length) % items.length;
    tabRefs.current[bounded]?.focus();
    onChange?.(bounded);
  };

  const onKeyDown = (event, index) => {
    switch (event.key) {
      case "ArrowRight":
      case "ArrowDown":
        event.preventDefault();
        focusAndSelect(index + 1);
        break;
      case "ArrowLeft":
      case "ArrowUp":
        event.preventDefault();
        focusAndSelect(index - 1);
        break;
      case "Home":
        event.preventDefault();
        focusAndSelect(0);
        break;
      case "End":
        event.preventDefault();
        focusAndSelect(items.length - 1);
        break;
      default:
        break;
    }
  };

  return (
    <div
      className={cn("flex items-center gap-2 overflow-x-auto py-1", className)}
      role="tablist"
      aria-label={ariaLabel}
    >
      {items.map((item, index) => {
        const selected = index === active;
        const tabId = `${prefix}-tab-${index}`;
        const panelId = `${prefix}-panel-${index}`;
        return (
          <button
            key={item.key ?? index}
            type="button"
            role="tab"
            id={tabId}
            aria-selected={selected}
            aria-controls={panelId}
            tabIndex={selected ? 0 : -1}
            onClick={() => onChange?.(index)}
            onKeyDown={(event) => onKeyDown(event, index)}
            ref={(element) => {
              tabRefs.current[index] = element;
            }}
            className={cn(
              "shrink-0 rounded-xl px-3 py-2 text-sm font-bold transition-colors",
              selected ? "bg-arena text-white" : "bg-white text-ink-soft border border-arena/15 hover:bg-arena/5"
            )}
          >
            {item.label}
          </button>
        );
      })}
    </div>
  );
}
